import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'iap',

  initialState: {
    ready: false,
    resolved: false,
  },
  reducers: {
    setIapReady(state, { payload }: PayloadAction<boolean>) {
      state.ready = payload;
      state.resolved = true;
    },
  },
});

export const iapActions = slice.actions;
export default slice.reducer;
